// src/pages/ViewAllPage.jsx

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Row, Col, Spin } from "antd";
import axiosInstance from "../api/axiosInstance";

const ViewAllPage = () => {
  const { type } = useParams(); // 🔥 dynamic filter
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axiosInstance.get(
          `/product-details?filters[product_groups][name][$eq]=${encodeURIComponent(
          type
        )}&fields[0]=title&fields[1]=slug&fields[2]=final_price&fields[3]=old_price&fields[4]=save_price&populate[images][fields][0]=url&populate[sub_product][fields][0]=slug`,
        );

        setData(res.data?.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [type]);

  if (loading) return <Spin className="mt-10" />;

  return (
    <div className="container px-4 md:px-0 py-10">
      <h2 className="text-2xl font-semibold mb-6 capitalize">
        {type.replaceAll("_", " ")}
      </h2>

      <Row gutter={[16, 16]}>
        {data.map((tour) => {
          const title = tour.title || tour.attributes?.title;
          const subSlug =
            tour.sub_product?.slug ||
            tour.attributes?.sub_product?.data?.attributes?.slug;

          const detailSlug = tour.slug || tour.attributes?.slug;

          const imageUrl =
            tour.images?.[0]?.url ||
            tour.attributes?.images?.data?.[0]?.attributes?.url;

          return (
            <Col xs={24} md={6} key={tour.id}>
              <div
                className="bg-white rounded-xl shadow cursor-pointer"
                onClick={() => navigate(`/${subSlug}/${detailSlug}`)}
              >
                <img
                  src={`${process.env.REACT_APP_API_URL}${imageUrl}`}
                  className="w-full h-[180px] object-cover rounded-t-xl"
                  alt={title}
                />

                <div className="p-4">
                  <div className="line-clamp-2 font-medium">{title}</div>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default ViewAllPage;
